import { CancellationType } from 'types';

import { formatPhoneNumbers } from './formats';

export const getCancellationModalTitle = (type: CancellationType | null) => {
  switch (type) {
    case CancellationType.DENIED:
      return 'Cancellation Not Permitted';
    default:
      return 'Cancel Appointment';
  }
};

export const getCancellationModalSubtitle = (type: CancellationType | null) => {
  switch (type) {
    case CancellationType.ALLOWED:
      return 'Are you sure you’d like to cancel this appointment?';

    case CancellationType.NOT_ALLOWED:
      return 'You are subject to a cancellation fee if you continue';

    case CancellationType.DENIED:
      return 'Cancellations are not permitted within 24 hours';
    default:
      return '';
  }
};

export const getCancellationModalBodyText = (
  type: CancellationType | null,
  phone: string
) => {
  switch (type) {
    case CancellationType.ALLOWED:
      return `To reschedule, please call ${formatPhoneNumbers(
        phone
      )} or use our online scheduling system.`;

    case CancellationType.NOT_ALLOWED:
      return `To reschedule, please call us at ${formatPhoneNumbers(
        phone
      )} or use our online booking system. Cancellations or changes made within 24 hours of your appointment may incur a cancellation fee.`;

    case CancellationType.DENIED:
      return `For assistance, please call us at ${formatPhoneNumbers(
        phone
      )}. We'll be happy to review your options. Please note that cancellations or missed appointments may be subject to a cancellation fee.`;

    default:
      return '';
  }
};
